export enum ProductTypes {
  Carpet = 'CARPET',
  Commission = 'COMMISSION',
  Cushion = 'CUSHION COVER',
  Delivery = 'DELIVERY',
  Extras = 'EXTRAS',
  Fabric = 'FABRIC',
  Label = 'LABEL',
  Lining = 'LINING',
  PatternBooks = 'PATTERN BOOKS',
  Sample = 'SAMPLE',
  Sundry = 'SUNDRY',
  Trimming = 'TRIMMING',
  Wallpaper = 'WALLPAPER',
  Yarn = 'YARN',
}
